import React from "react";
import { InterfaceRequirementListPageInitialState, PageNewState } from ".";

export const InterfaceRequirementListPageContext = React.createContext({
  pageState: InterfaceRequirementListPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
